package com.example.hukakmp.chat

import kotlinx.serialization.Serializable

@Serializable
data class HukaChatMessage(
    val text: String,
    val fromUser: Boolean,
)

sealed interface HukaChatResult {
    data class Success(val text: String) : HukaChatResult
    data class Error(val message: String) : HukaChatResult
}

expect val hukaChatAvailable: Boolean

expect suspend fun askHuka(
    message: String,
    history: List<HukaChatMessage>,
): HukaChatResult
